export const setAffectationMntRetenuALaSourceFRS = (value) => {
  return (dispatch) => {
    dispatch({ type: "AFF_MNT_RETENU_FRS", payload: value });
  };
};
